import { handleActions } from 'redux-actions';
import { initialState } from './constants';
import { allRequiredDocuments } from './action';
import { isServer } from 'utils';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [allRequiredDocuments]: {
    next: (state: State.AllRequiredDocuments, action: any): State.AllRequiredDocuments => ({
      ...state,
      exempReference: action.payload,
      exemptReferenceFetched: true,
      exemptReferenceFrontloadRequest: isServer,
      workExperienceDataFetched: true,
    }),
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions(ACTION_HANDLERS, initialState);
